//@ts-nocheck
import React, { FC } from "react";
import CanvasJSReact from "@canvasjs/react-charts";
import { InsightDay, UserSleepType } from "../../DTO";
import {
    formatPatientDateTime,
    patientDateKey,
} from "../../utils/health-report-format";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

export const ReportSleepChart: FC<{
    sleep: UserSleepType[];
    days?: InsightDay[];
}> = ({ sleep, days }) => {
    const recorded = sleep.map((item) => {
        const hours =
            (new Date(item.endDate).getTime() -
                new Date(item.startDate).getTime()) /
            3600000;
        const start = formatPatientDateTime(
            item.startDate,
            item.timezoneOffset,
        );
        const end = formatPatientDateTime(item.endDate, item.timezoneOffset);
        return {
            date: patientDateKey(item.startDate, item.timezoneOffset),
            hours,
            start: start.time,
            end: end.time,
        };
    });
    const chartDays = days?.length
        ? days
        : recorded.map((item) => ({
              date: item.date,
              name: new Date(item.date).toLocaleDateString(undefined, {
                  weekday: "short",
              }),
          }));
    const dataPoints = chartDays.map((day) => {
        const item = recorded.find((entry) => entry.date === day.date);
        return {
            label: day.name.slice(0, 3),
            date: day.date,
            y: item ? Number(item.hours.toFixed(2)) : null,
            start: item?.start,
            end: item?.end,
        };
    });
    const valid = dataPoints.filter(
        (point) => point.y !== null && Number.isFinite(point.y),
    );
    const average = valid.length
        ? valid.reduce((sum, point) => sum + point.y, 0) / valid.length
        : null;

    return (
        <section className="health-chart-panel">
            <header>
                <div>
                    <span>Weekly pattern</span>
                    <h2>Sleep duration</h2>
                </div>
                <p>
                    {average === null
                        ? "No recorded nights"
                        : `${average.toFixed(1)} hour average on recorded nights`}
                </p>
            </header>
            <CanvasJSChart
                options={{
                    animationEnabled: false,
                    backgroundColor: "transparent",
                    height: 320,
                    axisX: {
                        lineColor: "#d0d5dd",
                        tickColor: "#d0d5dd",
                        labelFontColor: "#475467",
                    },
                    axisY: {
                        includeZero: true,
                        maximum: 12,
                        interval: 2,
                        suffix: " h",
                        gridColor: "#eef1f4",
                        lineThickness: 0,
                        tickLength: 0,
                        labelFontColor: "#667085",
                        title: "Hours slept",
                    },
                    data: [
                        {
                            type: "column",
                            color: "#6875a8",
                            toolTipContent:
                                "<strong>{label}, {date}</strong><br/>{y} hours<br/>Bed {start} · Wake {end}",
                            dataPoints,
                        },
                    ],
                }}
            />
            <p className="health-chart-note">
                Blank days mean no sleep was recorded. They are not included in
                the average.
            </p>
        </section>
    );
};
